import { SearchService } from '@/services';

export default class SearchInfoHook {
  static async fetch(what, where, filtres, sort, qty, page, forYou, userLat, userLon) {
    const result = await SearchService.getSearchInfo(what, where, filtres, sort, qty, page, forYou, userLat, userLon);

    /**
     * HOOK Error handler
     * @type {boolean}
     */
    let error = true;
    if (!!result && !!result.data && result.data.errors === 0 && result.data.datas) {
      error = false;
    }

    // RG Hook
    const highlighting = result.data?.datas?.highlighting;
    const docs = result.data?.datas?.response?.docs;
    // docs: Array -> doc: Object
    // highlighting: Object -> Array -> Object
    if (docs && highlighting) {
      docs.forEach((doc) => {
        if (doc.id && highlighting[doc.id]) {
          Object.keys(highlighting[doc.id]).forEach((index) => {
            if (highlighting[doc.id][index] && highlighting[doc.id][index].length) {
              Object.defineProperty(doc, index, {
                value: [],
              });
              highlighting[doc.id][index].forEach((h) => {
                const newValue = h.replaceAll('<em>', '<em class="search-highlight added-api-hook">');
                doc[index].push(newValue);
              });
            }
          });
        }
      });
    }

    return {
      error,
      result,
    };
  }
}
